import { General } from "../../siteManagement/general";
import { FAIcon } from "../core/components/faIcon";
import { Helper } from "../core/util/helper";
import React from "react";
export default class ErrorApp extends React.Component<ErrorAppProps, any> {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        General.Sheet.Manager.getTopMostSheet().setTitle(this.props.message);
    }

    renderReadPermissionDeniedReasons = (reason) => {
        let errorText = Helper.getTranslation("Standard.Fehler.Grund") + reason.Reason;
        return <div style={{ marginTop: "10px", color: "#9E9E9E" }}>{errorText}
            {/*<div>FilePath:{reason.FilePath}</div>*/}
            {/*<div>LineNumber:{reason.LineNumber}</div>*/}
        </div>
    }

    renderAdditionalInfo = () => {
        if (this.props.additionalData?.readPermissionDeniedReasons) {
            return this.props.additionalData?.readPermissionDeniedReasons.map(this.renderReadPermissionDeniedReasons)
        }
        return null;
    }

    render() {
        return (
            <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <div><FAIcon name="exclamation-triangle" attributes={["8x"]} style={{ color: "#9E9E9E" }} /></div>
                <div style={{ marginTop: "10px", color: "#9E9E9E", fontWeight: "bolder" }}>{this.props.message}</div>
                {this.renderAdditionalInfo()}
            </div>
        );
    }
};

export interface ErrorAppProps {
    message: string;
    additionalData?: any;
}